import { formatShortDate } from "@/lib/utils";
import {
  getLocalizedSlug,
  type LocalizedSlug,
} from "@/lib/routing/url-builder";
import type { Locale } from "@/i18n/config";
import type { VisualType } from "@/lib/types";

export interface ArticleCardFields {
  title: string;
  href: string;
  visual: VisualType | null;
  categories: string[];
  date: string | undefined;
}

interface ArticleCardSource {
  title?: string | null;
  slug?: string | LocalizedSlug | null;
  visual?: VisualType | null;
  categories?: ({ name?: string | null } | null)[] | null;
  publishedAt?: string | null;
}

export function toArticleCardFields(
  article: ArticleCardSource,
  locale?: Locale,
): ArticleCardFields {
  return {
    title: article.title ?? "",
    href: resolveHref(article.slug, locale),
    visual: article.visual ?? null,
    categories: (article.categories ?? [])
      .map((category) => category?.name)
      .filter((name): name is string => Boolean(name)),
    date: formatShortDate(article.publishedAt ?? null),
  };
}

function resolveHref(
  slug: string | LocalizedSlug | null | undefined,
  locale: Locale | undefined,
): string {
  if (!slug) return "#";
  if (typeof slug === "string") return slug;
  return getLocalizedSlug(slug, locale ?? "en") ?? "#";
}
